import React, { useEffect, useState } from "react";
import "../../assets/css/login.css";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const RegisterModel = ({ showModal, emailAddress, closeModal, updateRecord, buttonCheck }) => {
 
  const [email, setEmail] = useState(); 
  const [mobilenumber, setMobileNumber] = useState();
  const [organization, setOrganization] = useState();
  const [totalEmployees, setTotalEmployees] = useState();
  //error hooks
  const [emailError, setEmailError] = useState(false);
  const [organizationError, setOrganizationError] = useState(false);
  const [mobilenumberError, setMobileNumberError] = useState(false);
  const [totalEmployeesError, setTotalEmployeesError] = useState(false);

  useEffect(() => {
    setEmail("");
    setMobileNumber("");
    setOrganization("");
    setTotalEmployees("")
    
    setEmailError(false);
    setOrganizationError(false);
    setMobileNumberError(false);
    setTotalEmployeesError(false);
  }, []);
  
  //form validation from here
  const mobilenumbervalidation = () => {
    let isValid = true;
    // var pattern = new RegExp(/^[6-9][0-9]$/);
    var pattern = new RegExp(/^[6-9]\d{9}$/);
    if (mobilenumber.trim() === "") {
      setMobileNumberError("Phone number is mandatory!");
      return false;
    } else if (!pattern.test(mobilenumber)) {
      setMobileNumberError("Enter a valid phone number!");
      return false;
    } else if (mobilenumber.length != 10) {
      setMobileNumberError("Mobile Number should contain have 10 digits only!");
      return false;
    } else {
      setMobileNumberError("");
      return true;
    }
  };

  const organizationValidation = () => {
    var pattern = new RegExp(/^[A-Za-z\s]+$/);
    if (organization.trim() === "") {
      setOrganizationError("Organization name is mandatory!");
      return false;
    } else if (!pattern.test(organization)) {
      setOrganizationError("Organization name should contain Alphabetic Characters only!");
      return false;
    } else if (organization[0] === " " || organization.slice(-1) === " ") {
      setOrganizationError("Organization name should not contain space!");
      return false;
    } else if (organization.length >= 50) {
      setOrganizationError("Organization name should contain 50 Characters only!");
      return false;
    } else {
      setOrganizationError("");
      return true;
    }
  };
  
  const totalEmployeeValidation = () => {
    if (totalEmployees === "") {
      setTotalEmployeesError("Total number of employee field is required!");
      return false;
    }  else {
      setTotalEmployeesError("");
      return true;
    }
  };

  const validateForm = () => {
    //Form Validation
    
    if (organizationValidation() &&
      mobilenumbervalidation() &&
      totalEmployeeValidation()
    ) {
      return true;
    } else {
      organizationValidation();
        mobilenumbervalidation();
        totalEmployeeValidation();
    }
    return false;
  };
  const CreateCustomerData = () => {
      if (validateForm()) {
          
          updateRecord({
            mobile: mobilenumber,
            company: organization,
            totalEmployees: totalEmployees
          });
          
          setEmail("");
          setMobileNumber("");
          setOrganization("");
          setTotalEmployees("")
          return false;
      } else {
        document.getElementById('saveBtn').removeAttribute('data-bs-dismiss')
        return false;
      }
  };
 
  useEffect(() => {
    // getRegionList();
  }, []);

  return (
    <div
      className={`modal fade  ${showModal ? "show" : ""}`}
      id="exampleModal"
      tabindex="-1"
      role={`${showModal ? 'dialog' : ""}`}
      aria-labelledby="exampleModalLabel"
      // aria-hidden="true"
      style={{ display: showModal ? 'block' : 'none',background: "black" }}
      area-model="false"
      showmodal={showModal}
    >
      <div className="modal-dialog">
        <div className="modal-content" style={{ borderRadius: "10px", marginTop: "25%"}}>
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
                Domain is not registered, Please enroll.
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => closeModal()}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="new_address_form">
              <div className="form_style">
                <div className="form_row">
                  <input
                    type="text"
                    name="email_id"
                    id="email_id"
                    placeholder="Enter Email Id"
                    value={emailAddress}
                    onChange={(e) => setEmail(emailAddress)}
                    readOnly={true}
                    autoFocus
                  />
                  {/* <span className='badge bg-danger m-1 p-1 rounded-pill'>{firstNameError}</span> */}
                  <div className="text-left text-small col-md-12 color_red">
                    {emailError}
                  </div>
                </div>
                <div className="form_row">
                  <input
                    type="text"
                    name="mobilenumber"
                    id="mobilenumber"
                    placeholder="Enter Mobile Number"
                    value={mobilenumber}
                    maxLength={10}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    onBlur={mobilenumbervalidation}
                  />
                  <div className="text-left text-small col-md-12 color_red">
                    {mobilenumberError}
                  </div>
                </div>
                <div className="form_row">
                  <input
                    type="text"
                    name="organization"
                    id="organization"
                    placeholder="Enter Organization/Institue Name"
                    value={organization}
                    onChange={(e) => setOrganization(e.target.value)}
                    onBlur={organizationValidation}
                  />
                  <div className="text-left text-small col-md-12 color_red">
                    {organizationError}
                  </div>
                </div>
                <div className="form_row">
                  <select
                    name="totalEmployees"
                    id="totalEmployees"
                    placeholder="Total number of Employess"
                    value={totalEmployees}
                    onChange={(e) => setTotalEmployees(e.target.value)}
                    onBlur={totalEmployeeValidation}
                  >
                    <option value="">Select Total Number Employess</option>
                    <option value="50 Member">50 Member</option>
                    <option value="51 -250 Member">51 -250 Member</option>
                    <option value="251 - 500 Member">251 - 500 Member</option>
                    <option value="501 - 2500 Member">501 - 2500 Member</option>
                    <option value="More Than 2500 Member">More Than 2500 Member</option>
                  </select>
                  <div className="text-left text-small col-md-12 color_red">
                    {totalEmployeesError}
                  </div>
                </div>
                <div className="form_row load_more_row">
                  <button
                    className="btn default_button_checkout"
                    // data-bs-dismiss={!showModal ? 'modal' : ''}
                    aria-label="Close" 
                    disabled={buttonCheck}
                    onClick={CreateCustomerData}
                    id="saveBtn"
                  >
                    {"Submit"}
                  </button>
                  {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-times"></i></button> */}
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="btn default_button_checkout close_address_box"
                    onClick={() => closeModal()}
                    id='cancelAddAddress'
                  >
                    {" "}
                    {"Cancel"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterModel;